import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.banner;

export const bannerSelectors = {
  banners: createSelector(selector, (state) => state.banners),
};
